import reframe from 'nike-re-framejs';

reframe.enableReactUnstableBatchedUpdates();
reframe.enableExperimentalFasterSubscribe();
